module.exports = __webpack_public_path__ + "img/img_83821_0_0.cce249fd.png";